export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.29-0859.47",
  commitId: "15f0fec30a10d6530e164d05b5ae48c23f6d3502",
  commitTime: "2026-06-29T08:59:47.000Z",
});
